import React from 'react';
import { PageHeader } from '../components/layout/PageHeader';
import { PricingTiers } from '../components/pricing/PricingTiers';
import { SectionHeading } from '../components/ui/SectionHeading';
import { FaqList } from '../components/ui/FaqList';
import { CtaBand } from '../components/ui/CtaBand';
import { carePaths } from '../data/carePaths';
import { faqs } from '../data/site';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { useBrand } from '../contexts/BrandContext';
export function Pricing() {
  const {
    brand
  } = useBrand();
  useDocumentMeta({
    title: `Pricing — ${brand.name}`,
    description: 'The symptom decoder and library are free. Membership is $45 a month, care paths from $79. Prices held for twelve months, cancel in two clicks.'
  });
  return <main className="w-full bg-cream" data-id="element-625" data-mp="1fi6ay0jjchbh">
      <PageHeader eyebrow="Pricing" title="The answers are free. The care has a price, and you can see it." intro="No consultation fee that appears at checkout, no titration surcharge, no discount that only shows up when you try to leave. Prices are held for twelve months from the day you start." data-id="element-626" data-mp="1fh4m8t9ljwba" />

      <section className="bg-cream" data-id="element-627" data-mp="1jiorae77lye7">
        <div className="mx-auto max-w-shell px-6 pb-20 pt-6 md:px-8 md:pb-28 md:pt-10" data-id="element-628" data-mp="14ok80syhsaif">
          <PricingTiers data-id="element-629" data-mp="19mbyrjnehql1" />
        </div>
      </section>

      <section className="bg-cream-light" data-id="element-630" data-mp="19oy3zcmtju03">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-24" data-id="element-631" data-mp="1xbwja6z7cvwf">
          <SectionHeading eyebrow="By care path" title="What each path costs with medication included." intro="Every price below includes clinician time, titration reviews, messaging, and the medication itself where one is prescribed." data-id="element-632" data-mp="22bj6n98qvsiy" />
          <div className="mt-12 overflow-x-auto" data-id="element-633" data-mp="1sjmuwvdqk3w9">
            <table className="w-full min-w-[40rem] text-left" data-id="element-634" data-mp="2gb25fbfo1ril">
              <caption className="sr-only" data-id="element-635" data-mp="2l20je4d6mdio">Monthly price by care path</caption>
              <thead data-id="element-636" data-mp="2l43jjh81tn14">
                <tr className="rule" data-id="element-637" data-mp="2uy0ooj4ddfm8">
                  <th scope="col" className="py-4 text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-638" data-mp="2uwy22ne2xzc4">
                    Care path
                  </th>
                  <th scope="col" className="py-4 text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-639" data-mp="2lx2l21xufa46">
                    Stage
                  </th>
                  <th scope="col" className="py-4 text-right text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-640" data-mp="2gxq2vuhx2r7x">
                    From
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-641" data-mp="228jzduc1qeu8">
                {carePaths.map(path => <tr key={path.slug} className="rule" data-id="element-642" data-mp="1y7qhbhlabu99">
                    <th scope="row" className="py-5 pr-6 font-serif text-xl font-normal text-ink" data-id="element-643" data-mp="1y9bbh63otb6l">
                      {path.name}
                    </th>
                    <td className="py-5 pr-6 text-ink-soft" data-id="element-644" data-mp="1o90wbfy3dtos">{path.category}</td>
                    <td className="py-5 text-right text-ink" data-id="element-645" data-mp="3ri7yvyddxcb">
                      ${path.priceFrom}
                      <span className="text-ink-muted" data-id="element-646" data-mp="8qmjvucoi96c"> {path.cadence}</span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="bg-cream" data-id="element-647" data-mp="hrkpgh2rmor1">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-24" data-id="element-648" data-mp="hqhw82hz0a7y">
          <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-649" data-mp="3h7pnk3cbr8f9">
            <SectionHeading eyebrow="Before you sign up" title="The questions people actually ask." data-id="element-650" data-mp="3m4zi1xekma9y" />
            <div data-id="element-651" data-mp="3q6ukj588mtpb">
              <FaqList items={faqs} data-id="element-652" data-mp="3q6b2zpmi27bt" />
            </div>
          </div>
        </div>
      </section>

      <CtaBand data-id="element-653" data-mp="3uymezquiljkq" />
    </main>;
}